import $ from 'jquery';
import { _GLOBALS, _TOKENS } from './globals.js';
import { Modal, Toast } from 'bootstrap';
import { loadingOverlay, Toasts, Modals } from './Helper.js';

import { detectWallets } from './ak_js_stuff/detectWallet.js';
import { connectWallet } from './ak_js_stuff/useWallet.js';
import { walletEvents } from './ak_js_stuff/walletEvents.js';
import { logit } from './ak_js_stuff/simpleLog.js';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(faHome, faStar, faChevronLeft, faChevronDown, faWallet, faCircleQuestion);

// Automatically replace <i> tags with SVG
dom.watch();

//let _WALLETS = [
//    {
//        name: "Coinbase",
//        icon: imageSrc+"coinbase_wallet.svg"
//    },
//    {
//        name: "Phantom",
//        icon: imageSrc+"phantom_wallet.svg"
//    },
//];

let _WALLETS = null;
let _SELECTED_WALLET = null;
let _ICONS_BASE_PATH = '/images/icons/';
let data = null;

let modalElement = null;
let modalInstance = null;

const _PAGE_ID = 'walletSelectionView';

const tpl = () => {
    
    let tpl = `
        <div id="${_PAGE_ID}" class="page-view transition-left">
            <ul class="list-group" id="walletList">
                <li class="list-group-item list-group-item-action" style="padding:20px" ><h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5></li>
                <li class="list-group-item list-group-item-action" style="padding:20px"  ><h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5></li>
                <li class="list-group-item list-group-item-action" style="padding:20px"  ><h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5></li>
            </ul>
        </div>`;
    
    return tpl;
}

export const view = async(data = null) => {
    _WALLETS = data?.wallets || await detectWallets();
    let html = tpl();
    return html;
}

export const init = async () => {
    let html = ``;
    if(_GLOBALS.ReferralProgramModule) {
        html = `
        <h1>Referral Manager</h1>
        `;
    }
    html += `
        <h5>Select your wallet</h5><div class="list-group" id="walletList">`;

    _WALLETS.forEach((wallet) => {
        if(_GLOBALS.DebugMode) console.log("Wallet", wallet);
        let detected = '';
        if (wallet.detected) {
            detected = `<span class="badge bg-success">Detected</span>`;
        }
        html += `
            <a href="#" class="list-group-item list-group-item-action " aria-current="true" data-wallet="${wallet.name}" onclick="selectWallet(this);">
                <div class="d-flex w-100 justify-content-between text-start">
                    <img src="${_ICONS_BASE_PATH}${wallet.icon}" class="img-fluid my-2" width="50"/>
                    <h5 class="mb-1 me-auto my-3">${wallet.name}</h5>
                    <small>${detected}</small>
                    
                </div>
                
            </a>            
        `;
    });
    html += `
            <div class="list-group-item list-group-item-action " aria-current="true" data-wallet="">
                <div class="d-flex w-100 justify-content-between text-start">
                    
                    <i class="fa-solid fa-question-circle fa-3x me-2"></i>
                    <h5 class="mb-1 me-auto my-1">I don't have a wallet
                    <br /><small>We recommend <a href="https://www.coinbase.com/de/wallet" target="_blank">Coinbase</a></small>
                    </h5>
                </div>
            </div>  
        `;
    html += `</div>`;

    if(_GLOBALS.ReferralProgramModule) {
        // Referral Program Module active
        html += `
            <h3 class="mt-4">How-To</h3>
            <ul class="list-group list-group-numbered">
                <li class="list-group-item" style="padding:20px">Select your wallet</li>
                <li class="list-group-item" style="padding:20px">Distribute commission rates (community and yourself)</li>
                <li class="list-group-item" style="padding:20px">Generate link</li>
                <li class="list-group-item" style="padding:20px">Copy & Paste Referral link in your networks</li>
            </ul>
        `;
    } 
    // Default wallet selection for buyer
    else {
        html += `
            <div class="bordered-box round-border p-3 mt-2 mb-2">
                <h2 class="">Pre-Seed Phase</h2>
                <p class="text-info">Ending 2024-02-28</p>
                <p>1 EQUI = 0.10 USD <span class="text-success">250% more return</span></p>
            </div>
            <div class="bordered-box round-border p-3 mb-2">
                <h2 class="">Seed Phase</h2>
                <p class="">2024-03-01 until 2024-05-31</p>
                <p>1 EQUI = 0.15 USD <span class="text-success">150% more return</span></p>
            </div>
            <div class="bordered-box round-border p-3 mb-2">
                <h2 class="">Series A</h2>
                <p class="">From 2024-06-01</p>
                <p>1 EQUI = 0.25 USD </p>
            </div>
        `;
    }
    $('#'+_PAGE_ID).empty().append(html);
}

export const selectWallet = async(el) => {
    el.classList.add('disabled'); // Adds the Bootstrap `.disabled` class
    el.style.pointerEvents = 'none'; // Ensures no pointer interactions

    let wallet = el.getAttribute('data-wallet');
    _SELECTED_WALLET = _WALLETS.find((element) => element.name === wallet);
    loadingOverlay.Show($(el));
    
    let connection = null;
    try {
        
        connection = await connectWallet(_SELECTED_WALLET);
        if(!connection) {
            Toasts.Error.Show('Wallet not installed');
        }
    } catch ( err ) {
        if(err.name === 'WalletConnectError') {
            Modals.DefaultWarning('No account selected', 'Please connect your wallet and select an account');
            //Router.To('walletSelection', {wallets:_WALLETS});
        } else {
            Modals.DefaultWarning('An error occured', err.message);
            //Router.To('walletSelection', {wallets:_WALLETS});
        }
    }
    
    loadingOverlay.Hide($(el));

    el.classList.remove('disabled');
    el.style.pointerEvents = '';

    if (!connection) {
        //Toasts.Error.Show("Wallet not installed");
    } else {
        Toasts.Success.Show("Connected");
        _GLOBALS.GA.track('selectedWallet', {
            page: 'WalletSelection',
            wallet: _SELECTED_WALLET.name 
        });
        if(_GLOBALS.ReferralProgramModule) {    
                Router.To('referral_config', {wallet:_WALLETS[0], pubkey:connection});
            } else {
                Router.To('payment', {wallet:_SELECTED_WALLET, pubkey:connection});
        }
    }
}
window.selectWallet = selectWallet;

